import React, { Component } from 'react'
import DeletePeople from '../../Services/Mutations/DeletePeople'
import { BrowserRouter, Route, Switch, Link } from 'react-router-dom'
import { Button, Modal, Table } from 'react-bootstrap'
import { Auth } from 'aws-amplify'
import 'react-date-range/dist/styles.css' // main style file
import 'react-date-range/dist/theme/default.css' // theme css file
import { DateRangePicker } from 'react-date-range'
import ListPeopleService from '../../Services/Queries/ListPeople'
import _ from 'lodash'
import { ToastContainer, toast } from 'react-toastify'
import GetUserPermissions from '../../Services/Queries/GetUserPermissions'
import { DefinedPermissions } from '../Constants/Permissions'
import 'react-toastify/dist/ReactToastify.css'
class ListPeople extends React.Component {
  toastStyle = {
    position: 'top-right',
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  }
  constructor(props) {
    super(props)

    this.state = {
      limit: 25,
      nextToken: null,
      headings: ['Actions', 'People Value', 'Name', 'Image', 'Type'],
      deleteModalVisible: false,
      selectedPeopleId: '',
      peopleList: [],
      loggedInUserPermissions: [],
    }

    this.loadMore = this.loadMore.bind(this)
  }
  loadMore = async () => {
    await this.getNextPeopleLists()
  }
  getPeopleLists = async (searchQuery) => {
    const input = {
      limit: this.state.limit,
    }
    if (searchQuery) {
      input.search = searchQuery
    }
    console.log(input, 'inputttt')
    const data = await ListPeopleService(input)
    console.log(data, 'dataaaaa')

    const permissionInput = {
      mobileNumber: Auth.user.attributes.phone_number,
    }
    const userPermissions = await GetUserPermissions(permissionInput)
    let permissions = []
    let permissionsArr = []
    if (userPermissions && userPermissions.userRolesAndPermissions) {
      userPermissions.userRolesAndPermissions.map((item) => {
        permissions.push(...item.permissions)
      })
      permissions.map((permission) => {
        permissionsArr.push(permission.name)
      })
    }
    console.log(permissionsArr, 'permissionsArr')

    this.setState({
      peopleList: data.items,
      nextToken: data.nextToken,
      loggedInUserPermissions: permissionsArr,
    })
  }
  getNextPeopleLists = async () => {
    const input = {
      limit: this.state.limit,
      nextToken: this.state.nextToken,
    }
    const data = await ListPeopleService(input)
    this.setState({
      peopleList: [...this.state.peopleList, ...data.items],
      nextToken: data.nextToken,
    })
  }
  onChangeSearch = (searchQuery) => {
    this.setState({ searchQuery: searchQuery })
    this.getPeopleLists(searchQuery)
  }
  async componentDidMount() {
    this.getPeopleLists()
  }
  openDeleteModal = (item) => {
    this.setState({ selectedPeopleId: item, deleteModalVisible: true })
  }
  closeDeleteModal = (item) => {
    this.setState({ selectedPeopleId: '', deleteModalVisible: false })
  }
  handleDelete = async () => {
    const item = this.state.selectedPeopleId
    this.setState({ deleteModalVisible: false })
    const input = { peopleValue: item.peopleValue }
    console.log(input, 'inputtttt')

    const data = await DeletePeople(input)
    console.log(data, 'delete dataaaa')
    if (data.statusCode == 'A254') {
      toast.success('People Deleted Successfully', this.toastStyle)

      const refreshedPeopleList = this.state.peopleList.filter((data) => {
        return data.peopleValue != item.peopleValue
      })
      this.setState({ peopleList: refreshedPeopleList })
    } else {
      toast.error('Failed To Delete People', this.toastStyle)
    }
  }
  renderDeleteConfirmationModal = () => {
    const { deleteModalVisible } = this.state
    return (
      <Modal show={deleteModalVisible} onHide={() => this.closeDeleteModal()}>
        <Modal.Body>
          <div className='row'>
            <text>Are you sure you want to delete this person?</text>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={() => this.closeDeleteModal()}>Cancel</Button>
          <Button onClick={() => this.handleDelete()}>Ok</Button>
        </Modal.Footer>
      </Modal>
    )
  }

  renderTable = (heading, contentList) => {
    return (
      <Table striped bordered hover responsive>
        <thead>
          <tr>
            {heading.map((head) => (
              <th>{head}</th>
            ))}
          </tr>
        </thead>
        <tbody>{contentList && contentList.map((row) => this.renderTableRow(row))}</tbody>
      </Table>
    )
  }

  renderTableRow = (item) => {
    const peopleValue = item.peopleValue
    const PK = peopleValue.replace('people#', '')
    const localOrStaging =
      window.location.href.indexOf('localhost') !== -1 ||
      window.location.href.indexOf('webstaging') !== -1

    const deletePeoplePermission = this.state.loggedInUserPermissions.includes(
      DefinedPermissions['deletePeoplePermission']
    )
    return (
      <tr>
        <td>
          <div class='row'>
            <div class='col-md-2'>
              <Link to={`/editPeople?${PK}`} target='_blank'>
                <i class='fas fa-pencil-alt' />
              </Link>
            </div>
            {deletePeoplePermission ? (
              <div
                class='col-md-2'
                onClick={() => {
                  this.openDeleteModal(item)
                }}
              >
                <i class='fas fa-trash' />
              </div>
            ) : null}
          </div>
        </td>
        <td>{item.peopleValue}</td>
        <td>{item.peopleName}</td>
        <td>
          <img style={{ maxWidth: '50%', height: 50 }} src={item.peopleCoverImage} />
        </td>
        <td>{item.peopleType}</td>
      </tr>
    )
  }

  render() {
    const { peopleList, headings } = this.state
    return (
      <section className='feed'>
        <ToastContainer
          position='top-right'
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
        {this.renderDeleteConfirmationModal()}
        {this.state.peopleList ? (
          <div style={{ marginTop: 10 }}>{this.renderTable(headings, peopleList)}</div>
        ) : (
          <div>No People To Display</div>
        )}
        {this.state.nextToken != null && (
          <button onClick={this.loadMore} type='button' className='load-more'>
            Load more
          </button>
        )}
      </section>
    )
  }
}

export default ListPeople
